import React from 'react';
import ContinentView from './ContinentView';

import banner from '../assets/oceania.jpg';
import australia from '../assets/australia.jpg';

const destinations = [
  { name: 'Australia', region: 'Australia', image: australia }
];

const Oceania = () => (
  <ContinentView
    continentName="Oceania"
    bannerImage={banner}
    description="Explore Oceania with The Half Time Travel. Discover Australia and amazing coastal adventures."
    destinations={destinations}
  />
);

export default Oceania;